import { parseParam } from "..";
import { dataStore } from "../../../store";
import {getConfigByInstanceId, setRenderDataSourcePaging} from "../../../store/common/action";
import { findAllData } from "../../dataSourceQuery";
import { findDataWithRelationships } from "../../dataSourceQuery/common";

/**
 * 刷新数据源函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const refreshDataSource = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) <=3) {
    let attrObject ,dataSourceProp, parameterType=false
    if (_size(_get(func, 'inParams')) === 3) {
      attrObject = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
      dataSourceProp = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
      parameterType = await parseParam(_get(func, 'inParams')[2], customParamsList, customFunctionParams, instanceId);
    } else if (_size(_get(func, 'inParams')) === 2) {
      let inParams_0 = _get(func, 'inParams')[0]
      if (inParams_0.paramType=="dataSource") {  // 如果第一个参数是数据源，那第二个参数就是参数类型(parameterType)
        // 数据源
        dataSourceProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
        // 参数类型
        parameterType = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
      } else {
        // 获取参数对象
        attrObject = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
        // 数据源
        dataSourceProp = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
      }
    } else {
      dataSourceProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    }
    const configTree = getConfigByInstanceId(instanceId);
    const dataSource = _get(configTree, ['dataSources', 'items']).find(item => item.prop === dataSourceProp);
    let result = _get(configTree, ['dataSources'])
    if (dataSource){
      result = findDataWithRelationships(_get(configTree, ['dataSources']),dataSource.prop)
      // console.log("refreshDataSource",result,attrObject)
      await findAllData(instanceId,_cloneDeep(result),dataStore.state.instanceData.get(instanceId),attrObject, parameterType);
    }
  }
}

/**
 * 更新数据源分页参数函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const updateDataSourcePaging = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    const component = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    const paging = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    let instanceData = dataStore.state.instanceData.get(instanceId);
    let renderData = instanceData.get(component?.dataSource);
    if (renderData) {
      const pageSize = _get(paging,['pageSize'])
      const pageIndex = _get(paging,['pageIndex'])
      if (pageIndex) {
        _set(renderData, ['paging','page'], pageIndex)
      }
      if (pageSize) {
        _set(renderData, ['paging','size'], pageSize)
      }
    }
    setRenderDataSourcePaging(instanceId,component.dataSource,_get(renderData, 'paging'));
  }
}
